"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MhUpload = void 0;

var _vuePropertyDecorator = require("vue-property-decorator");

var _http = require("../utils/http");

var _utils = require("../utils");

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
}

var MhUpload = (_dec = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: 99999
}), _dec3 = (0, _vuePropertyDecorator.Prop)(), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  _inherits(MhUpload, _Vue);

  var _super = _createSuper(MhUpload);

  function MhUpload() {
    var _this;

    _classCallCheck(this, MhUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_this, "value", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "maxLength", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "listType", _descriptor3, _assertThisInitialized(_this));

    _this.previewVisible = false;
    _this.previewImage = null;
    return _this;
  }

  _createClass(MhUpload, [{
    key: "handlePreview",
    value: function () {
      var _handlePreview = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!file.hash && !file.preview)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return getBase64(file.originFileObj);

              case 3:
                file.preview = _context.sent;

              case 4:
                this.previewImage = file.hash ? _http.fileDomain + '/' + file.hash : file.preview;
                this.previewVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handlePreview(_x) {
        return _handlePreview.apply(this, arguments);
      }

      return handlePreview;
    }()
  }, {
    key: "beforeUpload",
    value: function () {
      var _beforeUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_utils.fileToken.getToken && (!_utils.fileToken.token || _utils.fileToken.exp < new Date().valueOf()))) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return _utils.fileToken.getToken();

              case 3:
                _utils.fileToken.token = _context2.sent;
                _utils.fileToken.exp = new Date().valueOf() + 60 * 60 * 1000;
                this.$forceUpdate();

              case 6:
                return _context2.abrupt("return", file);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function beforeUpload(_x2) {
        return _beforeUpload.apply(this, arguments);
      }

      return beforeUpload;
    }()
  }, {
    key: "removeFile",
    value: function () {
      var _removeFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$emit('change', this.factValue.filter(function (v) {
                  return v.uid !== file.uid;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeFile(_x3) {
        return _removeFile.apply(this, arguments);
      }

      return removeFile;
    }()
  }, {
    key: "onChange",
    value: function onChange(_ref) {
      var file = _ref.file,
          fileList = _ref.fileList;

      if (file.status === 'done') {
        this.$emit('change', fileList.map(function (f) {
          return _objectSpread(_objectSpread({}, f), {}, {
            hash: f.hash || f.response.hash,
            xhr: undefined,
            lastModifiedDate: undefined,
            originFileObj: undefined,
            response: undefined,
            thumbUrl: undefined
          });
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var h = arguments[0];
      var token = _utils.fileToken.token;
      var beforeUpload = this.beforeUpload,
          fileList = this.fileList,
          onChange = this.onChange,
          removeFile = this.removeFile,
          maxLength = this.maxLength,
          previewVisible = this.previewVisible,
          previewImage = this.previewImage;
      return h("div", [h("a-upload", {
        "props": _objectSpread({}, _objectSpread(_objectSpread({}, this.$attrs), {}, {
          defaultFileList: fileList,
          beforeUpload: beforeUpload,
          data: {
            token: token
          },
          remove: removeFile
        })),
        "on": {
          "change": onChange,
          "preview": this.listType === 'picture-card' && this.handlePreview
        }
      }, [(!fileList || fileList.length < maxLength) && this.$slots.default]), h("a-modal", {
        "attrs": {
          "visible": previewVisible,
          "footer": null
        },
        "on": {
          "cancel": function cancel() {
            return _this2.previewVisible = false;
          }
        }
      }, [h("img", {
        "attrs": {
          "alt": "img",
          "src": previewImage
        },
        "style": "width: 100%"
      })])]);
    }
  }, {
    key: "factValue",
    get: function get() {
      return this.value.filter(function (i) {
        return i.hash;
      });
    }
  }, {
    key: "fileList",
    get: function get() {
      return this.factValue.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          url: _http.fileDomain + '/' + item.hash
        });
      });
    }
  }], [{
    key: "install",
    value: function install(vue) {
      vue.component('mh-upload', this);
    }
  }]);

  return MhUpload;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "maxLength", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "listType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.MhUpload = MhUpload;